export const replaceCommaWithSpace = (string: string): string => {
  return string.replace(',', ' ');
};
